// Importa i tuoi moduli principali.
// L'ordine non è critico, Webpack gestirà le dipendenze.
import './config.js';
import './api/ApiService.js';
import './api/AuthService.js';
import './api/authGuard.js';
import './pages/login/login.js';
import './pages/login/logout.js';
import './pages/login/reset.js';


console.log("App bundle loaded successfully.");